import component from '@/components/atomic/molecules/utils/portals/desktop-menu-container/templates/shop-now-template/menu-container/component';
import { Mapper } from '@multitenancy-spa/components-manager/esm/services/components-manager/enum';
import type { MappingConfig } from '@multitenancy-spa/components-manager/esm/services/components-manager/typings';
import { EnvVarsService } from '@multitenancy-spa/env-vars-service/esm/services/env-vars-service';

const ColumnLayoutList: MappingConfig = {
	resourceType: `${EnvVarsService.getVar('VITE_APP_ID')}/components/menucontainer`,
	mapper: Mapper.MAP_TO,
	component,
};

export default ColumnLayoutList;
